<template>
  <div class="card border-0 shadow-sm">
    <div class="card-header pb-0">
      <div class="d-flex align-items-center justify-content-between flex-wrap gap-2">
        <h6 class="mb-0">Balance de Repuestos</h6>
        <div class="d-flex align-items-center gap-2">
          <input
            v-model="selectedMonth"
            type="number"
            min="1"
            max="12"
            class="form-control form-control-sm"
            style="width: 70px;"
            placeholder="Mes"
            @change="loadData"
          />
          <input
            v-model="selectedYear"
            type="number"
            min="2020"
            max="2099"
            class="form-control form-control-sm"
            style="width: 90px;"
            placeholder="Año"
            @change="loadData"
          />
        </div>
      </div>
    </div>
    <div class="card-body">
      <div v-if="loading" class="text-center py-4">
        <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
      </div>
      <div v-else-if="data">
        <p class="text-sm text-secondary mb-3">{{ data.range_label }}</p>
        <div class="row g-3">
          <div class="col-12 col-md-4">
            <div class="card border-0 bg-light">
              <div class="card-body p-3 text-center">
                <p class="text-xs text-secondary mb-0">Ingresos por Repuestos</p>
                <h4 class="font-weight-bolder mb-1 text-success">{{ formatMoney(data.parts_income) }}</h4>
                <span class="text-xs" :class="data.variations.income_variation_percent >= 0 ? 'text-success' : 'text-danger'">
                  {{ data.variations.income_variation_percent >= 0 ? '↑' : '↓' }} {{ Math.abs(data.variations.income_variation_percent) }}% vs anterior
                </span>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="card border-0 bg-light">
              <div class="card-body p-3 text-center">
                <p class="text-xs text-secondary mb-0">Costo de Repuestos</p>
                <h4 class="font-weight-bolder mb-1 text-danger">{{ formatMoney(data.parts_cost) }}</h4>
                <span class="text-xs" :class="data.variations.cost_variation_percent >= 0 ? 'text-danger' : 'text-success'">
                  {{ data.variations.cost_variation_percent >= 0 ? '↑' : '↓' }} {{ Math.abs(data.variations.cost_variation_percent) }}% vs anterior
                </span>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="card border-0" :class="data.balance >= 0 ? 'bg-success' : 'bg-danger'">
              <div class="card-body p-3 text-center">
                <p class="text-xs text-white mb-0">Balance Neto</p>
                <h4 class="font-weight-bolder mb-1 text-white">{{ formatMoney(data.balance) }}</h4>
                <span class="text-xs text-white-50">
                  {{ data.variations.balance_variation_percent >= 0 ? '↑' : '↓' }} {{ Math.abs(data.variations.balance_variation_percent) }}% vs anterior
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PartsBalance',
  data() {
    const now = new Date();
    return {
      loading: false,
      data: null,
      selectedMonth: now.getMonth() + 1,
      selectedYear: now.getFullYear(),
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        const response = await this.$store.dispatch('metrics/getPartsBalance', {
          month: this.selectedMonth,
          year: this.selectedYear,
        });
        this.data = response.data;
      } catch (error) {
        console.error('Error loading parts balance:', error);
      } finally {
        this.loading = false;
      }
    },
    formatMoney(value) {
      return Number(value || 0).toLocaleString('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    },
  },
};
</script>
